import {
  A3_PERTURB_DEFAULT,
  A3_PERTURB_MAX,
  A3_PERTURB_MIN,
} from './constants';

/**
 * 解析 A3 画面增强默认开关（后台 /api/model/detail.enablePerturb）。
 * 仅认严格 true；未下发 / null / false 均视为默认关闭。
 */
export function resolveA3EnablePerturbDefault(
  enablePerturb?: boolean | null
): boolean {
  return enablePerturb === true;
}

/**
 * 解析 A3 画面增强步数默认值（后台 /api/model/detail.perturb）。
 * 未下发或非法回落常量默认 20，合法值钳制到 10–30。
 */
export function resolveA3PerturbStepsDefault(perturb?: number | null): number {
  if (perturb == null) return A3_PERTURB_DEFAULT;
  const n = Math.round(Number(perturb));
  if (!Number.isFinite(n)) return A3_PERTURB_DEFAULT;
  return Math.min(A3_PERTURB_MAX, Math.max(A3_PERTURB_MIN, n));
}

/** 从模型详情一次解析开关 + 步数默认 */
export function resolveA3PerturbConfigFromDetail(detail?: {
  enablePerturb?: boolean | null;
  perturb?: number | null;
}): { enablePerturb: boolean; perturb: number } {
  return {
    enablePerturb: resolveA3EnablePerturbDefault(detail?.enablePerturb),
    perturb: resolveA3PerturbStepsDefault(detail?.perturb),
  };
}
